<app-apps-banner></app-apps-banner>

<section class="mt-5 shipping-glossary">
  <div class="container">
    <div class="row pb-80">
      <div class="col-lg-8 pe-md-4 pe-xl-5 border-right sm-border-none">
        <div class="border-bottom pb-3 d-md-none d-block">
          <!-- <p class="back-link">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </p> -->
        <a class="back-link linked" routerLink="/apps">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </a>

        <div class="d-flex">
          <img src="../assets/images/icons/shipping-glossary.png" class="card-img-top img-fluid app-img me-4" alt="Container Specification">
          <h2>Shipping <br>Glossary</h2>
        </div>
      </div>

      <div class="d-md-flex align-items-md-center border-bottom pb-3 d-none d-md-flex">
        <img src="../assets/images/icons/shipping-glossary.png" class="card-img-top img-fluid app-img me-4" alt="Container Specification">
        <div>
          <!-- <p class="back-link mb-0">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </p> -->

        <a class="back-link linked" routerLink="/apps">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </a>
        <h2>Shipping Glossary</h2>
      </div>
    </div>

    <div class="row border-bottom mb-3">
      <div class="col-lg-12">
        <form class="apps-form-input d-lg-flex align-items-lg-center">
          <div class="glossary-form d-md-flex justify-content-between align-items-center">
            <div style="width: 100%;" class="form-group d-md-flex justify-content-between align-items-center  mb-0">
              <label style="white-space: nowrap;" for="exampleFormControlSelect1" class="text-white">Search Shipping Glossary</label>
              <span class="w-100 d-md-flex">
                <div class="w-100 pos-rel">
                  <span class="fa fa-search form-control-feedback"></span>
                  <input id="search" type="text" class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchShoppingGlossaryKey" [ngbTypeahead]="searchShippingGlossary" [inputFormatter]="formatteShippingGlossary" [resultFormatter]="formatteShippingGlossary"
                    [editable]='false' />
                    <!-- <input type="text" class="form-control" id="exampleInputEmail1" placeholder="English River"> -->
                  </div>
                  <button type="submit" class="btn btn-search" (click)="SearchByName()">Search</button>
                </span>
              </div>
              <div>
                <a href="javascript:void(0)" class="more-link" (click)="shwoAllShippingGlossaryByName()">Show All Glossary</a>
              </div>
            </div>
          </form>
        </div>

      </div>

      <div class="shippingGlossaryDetails bg-gray p-3">
        @if (isLoader) {
          <div class="loader">
            <div class="loader-icon">
              <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        }
        <p class="border-bottom pb-3"><strong>Shipping Glossary</strong></p>
        <div class="overflow-box">
          @for (item of searchDetailsList; track item) {
            <div class="bg-blue">
              <p class="blue-text"><strong>{{item.name}}</strong></p>
              <!-- <p >{{item.cDescription}}</p> -->
              <div class="d-gray-text mb-0" [innerHtml]= item.cDescription></div>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- <div class="col-lg-1">
    <div class="vl"></div>
  </div> -->

  <div class="col-lg-4 ps-md-4 ps-xl-5 pe-lg-0">
    <app-other-apps [menu]="'shipping'"></app-other-apps>
  </div>
</div>

</div>
</section>

<app-sat></app-sat>

<router-outlet></router-outlet>